import * as React from 'react';
import { Tooltip, Typography } from 'antd';
import classNames from 'classnames';
import { RowLayout } from '../grid';
import labelCss from './label.css';
const { Text } = Typography;

export interface ILabelProps {
    code?: string;
    italic?: boolean;
    strong?: boolean;
    underline?: boolean;
    label: string | React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export const Label = (props: ILabelProps) => {
    return (
        <Text
            key={props.code}
            className={props.className}
            strong={props.strong}
            italic={props.italic}
            underline={props.underline}
            style={props.style}
        >
            {props.label}
        </Text>
    );
};
export interface IFieldWithLabelProps {
    label: string;
    align?: 'left' | 'right' | 'center';
    children: React.ReactElement;
    hidden?: boolean;
}

const FieldWithLabel = (props: IFieldWithLabelProps) => {
    const { label, align = 'left', children, hidden } = props;
    return (
        !hidden && (
            <RowLayout
                childItems={[
                    <div className={classNames('ant-form-item-label', labelCss.label)} style={{ textAlign: align }}>
                        <label>{label}</label>
                    </div>,
                    React.cloneElement(children, {
                        className: classNames(labelCss.item, children.props.className),
                    }),
                ]}
                childCols={[5, 19]}
            />
        )
    );
};
export { Typography, FieldWithLabel };
